import { render, staticRenderFns } from "./TrafficConfigList.vue?vue&type=template&id=5066bfa8&scoped=true&"
import script from "./TrafficConfigList.vue?vue&type=script&lang=js&"
export * from "./TrafficConfigList.vue?vue&type=script&lang=js&"
import style0 from "./TrafficConfigList.vue?vue&type=style&index=0&id=5066bfa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5066bfa8",
  null
  
)

export default component.exports